import { DestinationUrlValue } from '../elements/Fields'
import { filterDestinationUrlsByCatalog } from './filterDestinationUrlsByCatalog'

interface GetCurrentDestinationValuesParams {
  pendingReviewMode: boolean
  pendingValue?: DestinationUrlValue[] | null
  isSingleDestination: boolean
  destinationUrl?: string | null
  destinationUrls?: DestinationUrlValue[] | null
  destinationsConfig?: DestinationUrlsConfig[]
  catalogLoaded?: boolean
}

// What's actually filled in right now: the live edited value while the
// sub-publisher is reviewing, otherwise the saved one. A multi-brand
// input that's cleared is dropped from the array entirely (see Fields.tsx)
// rather than kept as an empty-url entry, so "not all filled" means fewer
// filled entries than the number of destinations actually expected. The
// saved list is filtered by the loaded catalog so a publisher that left it
// is neither shown as an editable field nor silently resubmitted on approve.
export const getCurrentDestinationValues = ({
  pendingReviewMode,
  pendingValue,
  isSingleDestination,
  destinationUrl,
  destinationUrls,
  destinationsConfig,
  catalogLoaded = false
}: GetCurrentDestinationValuesParams): DestinationUrlValue[] => {
  let singleOrMultiValues: DestinationUrlValue[]

  if (!isSingleDestination) {
    singleOrMultiValues = filterDestinationUrlsByCatalog(
      destinationUrls || [],
      destinationsConfig,
      catalogLoaded
    )
  } else if (destinationUrl) {
    singleOrMultiValues = [{ url: destinationUrl }]
  } else {
    singleOrMultiValues = []
  }

  return pendingReviewMode
    ? (pendingValue ?? singleOrMultiValues)
    : singleOrMultiValues
}
